
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rental-listings",
      function () {
        return require("private-next-pages/rental-listings/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rental-listings"])
      });
    }
  